import PropTypes from 'prop-types'

const propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.number.isRequired,
  completeHandler: PropTypes.func,
}

export default propTypes
